import { Injectable } from "@angular/core";
import { Subject, Observable, BehaviorSubject } from "rxjs";
import { AngularFireAuth } from "@angular/fire/auth";
import * as firebase from "firebase";
import {
  MDBModalService,
  MDBModalRef,
  ToastService
} from "ng-uikit-pro-standard";
import { NoAccessComponent } from "src/app/login/components/popups/no-access/no-access.component";
import { User } from "../user/user.model";

@Injectable({
  providedIn: "root"
})
export class AuthService {
  private isAdmin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  private isOwner: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  private loggedIn: Subject<boolean> = new Subject<boolean>();

  modalRef: MDBModalRef;

  get user(): firebase.User {
    return this.af.auth.currentUser;
  }
  constructor(public af: AngularFireAuth, private toast: ToastService) {
    this.subscribe();
  }

  subscribe = () => this.af.authState.subscribe(() => this.updateLoginState());
  updateLoginState() {
    if (this.user != null) {
      this.loggedIn.next(true);
    } else {
      this.loggedIn.next(false);
    }
  }

  get isLoggedIn(): Observable<boolean> {
    return this.loggedIn.asObservable();
  }

  changeAdmin = (value: boolean) => this.isAdmin.next(value);

  changeOwner = (value: boolean) => this.isOwner.next(value);

  // doGoogleLogin() {
  //   return new Promise<any>((resolve, reject) => {
  //     let provider = new firebase.auth.GoogleAuthProvider();
  //     provider.addScope("profile");
  //     provider.addScope("email");
  //     provider.setCustomParameters({
  //       login_hint: "user@example.com",
  //       prompt: "select_account"
  //     });
  //     this.af.auth.signInWithPopup(provider).then(res => {
  //       resolve(res);
  //       firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
  //     });
  //   });
  // }

  async exists(email: string): Promise<boolean> {
    let x = await firebase.auth().fetchSignInMethodsForEmail(email);
    return x.length != 0;
  }

  async signInWithEmailAndPassword(
    email: string,
    password: string,
    remember: boolean
  ): Promise<void> {
    let persistence = remember
      ? firebase.auth.Auth.Persistence.LOCAL
      : firebase.auth.Auth.Persistence.NONE;
    await firebase.auth().setPersistence(persistence);
    await firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .catch(reject => {
        this.toast.error(
          "There was a problem with the password you have provided. Please try again!",
          "Invalid Sign In",
          { opacity: 1 }
        );
      });
  }

  logout = () =>
    this.af.auth.signOut().then(() => {
      console.log(this.af.auth);
    });

  canAccess = (type: string) =>
    type != null && (type == "LineLeapAdmin" || type == "VenueAdmin");

  updateUser() {
    this.loggedIn.next(true);
  }

  sendPasswordResetEmail(email: string) {
    firebase.auth().sendPasswordResetEmail(email);
  }
}
